<script lang="ts">
import { defineComponent, PropType } from 'vue'
import InputProfileName from '@/components/lead/InputProfileName.vue'
import InputProfileCareer from '@/components/lead/InputProfileCareer.vue'
import PersonNameForImmedio from '@/components/lead/PersonNameForImmedio.vue'

export default defineComponent({
  name: 'InputLead',

  components: {
    InputProfileName,
    InputProfileCareer,
    PersonNameForImmedio,
  },

  props: {
    namespace: {
      type: String,
      default: '',
    },

    userLeadInfo: {
      type: Object as PropType<UserLeadInfo>,
      required: true,
    },
  },

  emits: [
    'update:lastName',
    'update:firstName',
    'update:lastNameKana',
    'update:firstNameKana',
    'update:companyName',
    'update:industry',
    'update:scale',
    'update:listingStatus',
    'update:profession',
    'update:professionDomain',
    'open:professionDomain',
    'close:professionDomain',
    'update:positionLevel',
    'update:departmentAndPosition',
    'update:workMailAddress',
    'update:phoneNumber',
    'select:companyLeadInfo',
    'reset:corporateZipcode',
    'error'
  ],
})
</script>

<template>
  <div class="div">
    <div class="o-heading__section">
      <h2 class="o-heading__section--item">
        <slot name="heading">
          資料を読むには<span class="span u-text__block">
            次の項目をご入力ください
          </span>
        </slot>
      </h2>
    <!-- /.o-heading__section --></div>

    <InputProfileName
      :user-lead-info="userLeadInfo"
      :namespace="namespace"
      @update:last-name="$emit('update:lastName', $event)"
      @update:first-name="$emit('update:firstName', $event)"
      @update:last-name-kana="$emit('update:lastNameKana', $event)"
      @update:first-name-kana="$emit('update:firstNameKana', $event)" />

    <InputProfileCareer
      :user-lead-info="userLeadInfo"
      :namespace="namespace"
      @update:company-name="$emit('update:companyName', $event)"
      @update:industry="$emit('update:industry', $event)"
      @update:scale="$emit('update:scale', $event)"
      @update:listing-status="$emit('update:listingStatus', $event)"
      @update:profession="$emit('update:profession', $event)"
      @update:profession-domain="$emit('update:professionDomain', $event)"
      @open:profession-domain="$emit('open:professionDomain')"
      @close:profession-domain="$emit('close:professionDomain')"
      @update:position-level="$emit('update:positionLevel', $event)"
      @update:department-and-position="$emit('update:departmentAndPosition', $event)"
      @update:work-mail-address="$emit('update:workMailAddress', $event)"
      @update:phone-number="$emit('update:phoneNumber', $event)"
      @select:company-lead-info="$emit('select:companyLeadInfo', $event)"
      @reset:corporate-zipcode="$emit('reset:corporateZipcode', '')" />

    <PersonNameForImmedio
      :first-name="userLeadInfo.firstName?.value"
      :last-name="userLeadInfo.lastName?.value" />

    <div class="o-note__general u-text__small">
      <p class="o-note__general--item">上記の内容はBizHint会員情報にも反映されます。<br>
        正確な情報のご入力をお願いいたします。虚偽や不正があった場合は、サービスの利用を停止させていただく場合があります。
      </p>
    <!-- /.o-note__general --></div>
  </div>
</template>

<style lang="sass" scoped>
// object
.o-heading__section
  $root: &

  & &--item
    font:
      size: $font-normal
      weight: bold
    text-align: center

  +breakpoint
    #{$root}--item
      font-size: $font-small
</style>
